// @flow

import fetchPRS from './fetchprs';
import { SearchEndpoint } from './config';
import { handleNetworkError } from './ui';

export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_DETAILS_SUCCESS = 'SEARCH_DETAILS_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const SEARCH_UPDATE_PARAM = 'SEARCH_UPDATE_PARAM';
export const SEARCH_UPDATE_META = 'SEARCH_UPDATE_META';
export const SEARCH_CHANGE_TYPE = 'SEARCH_CHANGE_TYPE';
export const SEARCH_RESET_PARAMS = 'SEARCH_RESET_PARAMS';
export const SEARCH_HISTORY_RECORD = 'SEARCH_HISTORY_RECORD';
export const SEARCH_HISTORY_REMOVE = 'SEARCH_HISTORY_REMOVE';
export const SEARCH_LOADED_DETAILS_URL = 'SEARCH_LOADED_DETAILS_URL';
export const SEARCH_EXTRACT_POSSIBLE_MATCHES = 'SEARCH_EXTRACT_POSSIBLE_MATCHES';
export const SEARCH_CONSUME_HISTORY_ITEM = 'SEARCH_CONSUME_HISTORY_ITEM';

const updateParam = data => ({ type: SEARCH_UPDATE_PARAM, params: data });

const updateMeta = data => ({ type: SEARCH_UPDATE_META, params: data });

const changeType = type => ({ type: SEARCH_CHANGE_TYPE, searchType: type });

const searchStart = () => ({ type: SEARCH_START });

const searchSuccess = data => ({ type: SEARCH_SUCCESS, payload: data });

const searchDetailsSuccess = data => ({ type: SEARCH_DETAILS_SUCCESS, payload: data });

const searchFailed = error => ({ type: SEARCH_FAILURE, payload: error });

const searchReset = () => ({ type: SEARCH_RESET_PARAMS });

const searchHistoryRecord = title => ({ type: SEARCH_HISTORY_RECORD, title });

const searchHistoryRemove = () => ({ type: SEARCH_HISTORY_REMOVE });

const searchLoadedDetailsUrl = url => ({ type: SEARCH_LOADED_DETAILS_URL, url });

const searchExtractPossibleMatches = () => ({ type: SEARCH_EXTRACT_POSSIBLE_MATCHES });

const searchConsumeHistoryItem = () => ({ type: SEARCH_CONSUME_HISTORY_ITEM });

export const changeSearchType = (type: string) => (dispatch) => {
  dispatch(changeType(type));
};

export const updateSearchParam = (name: string, value: string) => (dispatch) => {
  dispatch(updateParam({ name, value }));
};

export const updateSearchMeta = (name: string, value: string) => (dispatch) => {
  dispatch(updateMeta({ name, value }));
};

export const resetSearchPrams = () => (dispatch) => {
  dispatch(searchReset());
};

export const addCurrentSearchParamsToHistory = () => (dispatch, getState) => {
  const { searchDetails } = getState().search;
  const title = (searchDetails.titles &&
    searchDetails.titles.find(v => v.entityTitle === 'Registered Title').entityValue) || '---';
  dispatch(searchHistoryRecord(title));
};

export const removeLastItemFromSearchHistory = () => (dispatch) => {
  dispatch(searchHistoryRemove());
};

export const extractPossibleMatchesFromSearch = () => (dispatch) => {
  dispatch(searchExtractPossibleMatches());
};

export const consumeSearchHistoryItem = () => (dispatch) => {
  dispatch(searchConsumeHistoryItem());
};

export const getMyWorks = searchParams => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/myworks?profileId=${profileId}&pageLength=${searchParams.pageLength}&pageNumber=${searchParams.pageNumber}`;

  dispatch(searchStart());
  return fetchPRS(searchUrl, dispatch)
    .then(data => dispatch(searchSuccess(data)))
    .catch((error: Error) => {
      handleNetworkError(dispatch, error, () => getMyWorks(searchParams));
      dispatch(searchFailed(error));
    });
};

export const searchByArtist = searchParams => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/works/byartist?artist=${searchParams.artist}&workTitle=${searchParams.title}&profileId=${profileId}&pageLength=${searchParams.pageLength}&pageNumber=${searchParams.pageNumber}`;

  dispatch(searchStart());
  return fetchPRS(searchUrl, dispatch)
    .then(data => dispatch(searchSuccess(data)))
    .catch((error: Error) => {
      handleNetworkError(dispatch, error, () => searchByArtist(searchParams));
      dispatch(searchFailed(error));
    });
};

export const searchByAuthor = searchParams => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/works/byauthor?firstName=${searchParams.firstName}&lastName=${searchParams.lastName}&workTitle=${searchParams.workTitle}&profileId=${profileId}&pageLength=${searchParams.pageLength}&pageNumber=${searchParams.pageNumber}`;

  dispatch(searchStart());
  return fetchPRS(searchUrl, dispatch)
    .then(data => dispatch(searchSuccess(data)))
    .catch((error: Error) => {
      handleNetworkError(dispatch, error, () => searchByAuthor(searchParams));
      dispatch(searchFailed(error));
    });
};

export const searchByPublisher = searchParams => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/works/bypublisher?publisher=${searchParams.publisher}&profileId=${profileId}&pageLength=${searchParams.pageLength}&pageNumber=${searchParams.pageNumber}`;

  dispatch(searchStart());
  return fetchPRS(searchUrl, dispatch)
    .then(data => dispatch(searchSuccess(data)))
    .catch((error: Error) => {
      handleNetworkError(dispatch, error, () => searchByPublisher(searchParams));
      dispatch(searchFailed(error));
    });
};

export const searchByCae = searchParams => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/works/bycae?caeNumber=${searchParams.caeNumber}&profileId=${profileId}&pageLength=${searchParams.pageLength}&pageNumber=${searchParams.pageNumber}`;

  dispatch(searchStart());
  return fetchPRS(searchUrl, dispatch)
    .then(data => dispatch(searchSuccess(data)))
    .catch((error: Error) => {
      handleNetworkError(dispatch, error, () => searchByCae(searchParams));
      dispatch(searchFailed(error));
    });
};

export const workDetails = searchParams => (dispatch, getState) => {
  const { loadedDetailsUrl } = getState().search;
  const profileId = localStorage.getItem('profileId');
  const searchUrl = `${SearchEndpoint}/work/${searchParams.workNumber}/${searchParams.workNumberType}?profileId=${profileId}`;

  if (loadedDetailsUrl !== searchUrl) {
    dispatch(searchStart());
    return fetchPRS(searchUrl, dispatch)
      .then(data => dispatch(searchDetailsSuccess(data)))
      .then(() => dispatch(searchLoadedDetailsUrl(searchUrl)))
      .catch((error: Error) => {
        handleNetworkError(dispatch, error, () => workDetails(searchParams));
        dispatch(searchFailed(error));
      });
  }
  return Promise.resolve(false);
};

const defaultSearchParams = {
  pageLength: 15,
  pageNumber: 0,
  title: '',
  artist: '',
  firstName: '',
  lastName: '',
  workTitle: '',
  publisher: '',
  caeNumber: '',
  cardsPerPage: 3,
  searched: false,
  workNumber: '',
  workNumberType: '',
};

export const defaultState = {
  searchDetails: {},
  search: {},
  searchParams: defaultSearchParams,
  searchMeta: {},
  searchParamsHistory: [],
  possibleMatches: [],
  fetching: false,
  searchBy: 'artist',
  loadedDetailsUrl: '',
};

const searchParamsHistory = (state, action, parentState) => {
  switch (action.type) {
    case SEARCH_HISTORY_RECORD:
      return [{
        title: action.title,
        page: window.location.hash.slice(1),
        searchParams: parentState.searchParams,
        searchDetails: parentState.searchDetails,
        searchMeta: parentState.searchMeta,
      }, ...state];
    case SEARCH_HISTORY_REMOVE:
    case SEARCH_CONSUME_HISTORY_ITEM:
      return state.slice(1);
    default:
      return state;
  }
};

const SearchReducer = (state: Object = defaultState, action: Object = {}) => {
  switch (action.type) {
    case SEARCH_CHANGE_TYPE:
      return Object.assign({}, state, { searchBy: action.searchType });
    case SEARCH_UPDATE_PARAM:
      return Object.assign({}, state,
        {
          searchParams: Object.assign({}, state.searchParams, {
            [action.params.name]: action.params.value,
          }),
        });
    case SEARCH_UPDATE_META:
      return Object.assign({}, state,
        {
          searchMeta: Object.assign({}, state.searchMeta, {
            [action.params.name]: action.params.value,
          }),
        });
    case SEARCH_START:
      return Object.assign({}, state, {
        fetching: true,
      });
    case SEARCH_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        search: action.payload,
      });
    case SEARCH_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        searchDetails: action.payload,
      });
    case SEARCH_FAILURE:
      return Object.assign({}, state, {
        fetching: false,
        error: action.payload,
      });
    case SEARCH_RESET_PARAMS:
      return Object.assign({}, state, {
        searchParams: defaultSearchParams,
        searchMeta: {},
      });
    case SEARCH_LOADED_DETAILS_URL:
      return Object.assign({}, state, {
        loadedDetailsUrl: action.url,
      });
    case SEARCH_HISTORY_RECORD:
    case SEARCH_HISTORY_REMOVE:
      return Object.assign({}, state, {
        searchParamsHistory:
          searchParamsHistory(state.searchParamsHistory, action, state),
      });
    case SEARCH_CONSUME_HISTORY_ITEM:
      if (state.searchParamsHistory.length > 0) {
        return Object.assign({}, state, {
          searchParams: Object.assign({}, state.searchParamsHistory[0].searchParams),
          searchDetails: Object.assign({}, state.searchParamsHistory[0].searchDetails),
          searchMeta: Object.assign({}, state.searchParamsHistory[0].searchMeta),
          searchParamsHistory:
            searchParamsHistory(state.searchParamsHistory, action, state),
        });
      }
      return state;
    case SEARCH_EXTRACT_POSSIBLE_MATCHES:
      return Object.assign({}, state, {
        possibleMatches: Object.assign({}, state.search.search.workMatches),
      });
    default:
      return state;
  }
};

export default SearchReducer;
